<template>
    <div>
        <div class="comment-footer" data-spm="comment-reply">
            <!-- 评论按钮 -->
            <div class="input-btn" @click="showTextareaShow">{{ btnText }}</div>
            <!-- 评论 -->
            <div class="comment-icon" @click="handleJump">
                <img class="icon" :src="commentImg"/>
                <div class="comment-count" v-if="commentTxt">{{ commentTxt }}</div>
            </div>
            <!-- 微信 -->
            <div class="wx-share" @click="handleShare('wx')"></div>
            <!-- 微博 -->
            <div class="wb-share" @click="handleShare('wb')"></div>
            <!-- 朋友圈 -->
            <div class="wxline-share" @click="handleShare('wechattimeline')"></div>
        </div>
        <CommentTextarea v-if="showCommentTextarea" @closeMask="changeTextareaShow(false)" :placeholderText="btnText" @addCommentCount="addCommentCount"/>
    </div>
</template>

<script>
import { publishComment,getCommentCount } from '../../js/article-main/request/api'
import localStorageUtil from '../../_utils/localstorageUtil'
import CommentTextarea from '../article-main/comment-textarea.vue'

const textList = [
  "让大家听到你的声音",
  "分享见解，获得成长",
  "有话要说，快来评论",
  "快来留下你的想法吧",
  "写下这一刻的想法",
];


export default {
  name: "FooterComment",
  components:{
      CommentTextarea,
  },
  data() {
    return {
        btnText: textList[Math.floor(Math.random() * textList.length)],
        commentCount: 0,
        commentType: 0, // 0-评论 1-正文
        commentImg: "https://statics.itc.cn/mptc-mpfe/img/article/icon_comment.png",
        showCommentTextarea: false,
    };
  },
  computed: {
      commentTxt() {
          return this.commentType == 1 ? '正文' : this.setCount(this.commentCount || 0)
      }
  },
  mounted() {
      this.handleCache()
      this.getCommentCount()
      window?.eventBus?.$on('showCommentTextarea',this.changeTextareaShow)
  },
  methods: {
    // 发布成功，评论数+1
    addCommentCount() {
        this.commentCount = this.commentCount + 1
    },
    showTextareaShow() {
        window.sohuSpm?.sendAction({ acode: 10925 });
        this.changeTextareaShow()
    },
    handleJump() {
        if(this.commentType == 1) {
            window.scrollTo({top:0,behavior:'smooth'});
        }else {
            window.scrollTo({top:document.body.scrollHeight,behavior:'smooth'});
        }
        this.commentType = this.commentType == 1 ? 0 : 1
    },
    // 处理缓存中未发布的评论
    handleCache() {
        const unpublishComment = localStorageUtil.getItem(`${window.cfgs?.newsId}_comment`)
        if(window.userInfo?.userId && unpublishComment){
            localStorageUtil.removeItem(`${window.cfgs?.newsId}_comment`)
            publishComment(unpublishComment).then((res)=>{
                if(res.code == 200) {
                window.h5_sohu.plugin.api.call('toast',
                    {text:'发布成功',type:1},
                    function(){})
                }else if(res.code == 417) { // 封禁
                    window?.EVENT_BUS?.$emit('showBannedNotice')
                }
                else {
                    window.h5_sohu.plugin.api.call('toast',
                        {text:'发布失败',type:2},
                        function(){})
                }
            }).catch((e)=>{
                window.h5_sohu.plugin.api.call('toast',
                    {text:'发布失败',type:2},
                    function(){})
            })
        }else {
            localStorageUtil.removeItem(`${window.cfgs?.newsId}_comment`)
        }
    },
    changeTextareaShow(status) {
        if(status ===  false) {
            this.showCommentTextarea = status
            return
        }
        this.showCommentTextarea = true
    },
    async getCommentCount() {
        try {
            const res = await getCommentCount()
            if(res.code == 1) {
                this.commentCount = Math.max(res.data?.outerCmtSum , res.data?.comments?.length)
            }
        } catch (error) {
            console.log(error)
        }
    },
    handleShare(type) {
        switch(type) {
            case 'wx':
                window.h5_sohu.plugin.api.call('shareToWeChat', {},function(){});
                break;
            case 'wb':
                window.h5_sohu.plugin.api.call('sinaweibo', {},function(){});
                break
            case 'wechattimeline':
                window.h5_sohu.plugin.api.call('wechattimeline', {},function(){});
                break
        }
    },
    setCount(count) {
      let num = "";
      if (999 > count > 0) {
        num = count;
      } else if (count > 999) {
        num = `999+`;
      }
      return num;
    },
  },
};
</script>
<style lang="less" scoped>
.comment-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 96px; /*px*/
  background: white;
  box-shadow: inset 0px 1px 0px 0px #ebebeb;
  border-top: 1px solid #ebebeb; /*px*/
  padding: 0 28px; /*px*/
  z-index: 1000;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .comment-icon {
    width: 40px; /*px*/
    height: 40px; /*px*/
    position: relative;
    margin-left: 40px; /*px*/
    .icon {
      width: 40px; /*px*/
      height: 40px; /*px*/
      position: absolute;
      right: 0;
      top: 0;
    }
    .comment-count {
      position: absolute;
      width: fit-content;
      transform: translate(-40%, -50%);
      height: 26px; /*px*/
      line-height: 26px; /*px*/
      height: 28px; /*px*/
      background: #ffd100;
      border: 2px solid #ffffff; /*px*/
      display: flex;
      align-items: center;
      top: 0px;
      left: 32px; /* px */
      color: #111111;
      font-size: 24px; /* px */
      padding: 0 10px;
      text-align: center;
      border-radius: 13px; /* px */
      box-shadow: 0 0 3px 3px #f2f2f2;
      font-weight: 700;
      white-space: nowrap;
    }
  }
  .input-btn {
    flex: 1;
    height: 64px; /*px*/
    border-radius: 32px; /*px*/
    background: #f2f2f2;
    padding: 12px 24px; /*px*/
    font-size: 28px; /*px*/
    box-sizing: border-box;
    color: #757575;
    display: flex;
    align-items: center;
  }
  .wx-share {
    margin-left: 40px; /*px*/
    width: 40px; /*px*/
    height: 40px; /*px*/
    background: url('../../less/images/icon_wechat3@2x.png') no-repeat;
    background-size: 100% 100%;
  }
  .wb-share {
    margin-left: 40px; /*px*/
    width: 40px; /*px*/
    height: 40px; /*px*/
    background: url('../../less/images/icon_weibo3@2x.png') no-repeat;
    background-size: 100% 100%;
  }
  .wxline-share {
    margin-left: 40px; /*px*/
    width: 40px; /*px*/
    height: 40px; /*px*/
    background: url('../../less/images/icon_moment3@2x.png') no-repeat;
    background-size: 100% 100%;
  }
}
</style>